module.exports = __webpack_public_path__ + "img/327696.2409269e.png";